// Feature: OfferBoardingPlaces/Components/SaveBoardingPlacesAsTemplateDialog.tsx
import React from 'react';
import SaveAsTemplateDialog from '../../Shared/Components/SaveAsTemplateDialog/SaveAsTemplateDialog';
import { useCreateBoardingPlaceTemplateMutation } from '../Service/boardingPlaceTemplatesApi';
import { SaveBoardingPlacesAsTemplateDialogProps } from './SaveBoardingPlacesAsTemplateDialogType';

const SaveBoardingPlacesAsTemplateDialog = ({
  open,
  onClose,
  data,
  onSuccess,
}: SaveBoardingPlacesAsTemplateDialogProps) => {
  const [createBoardingTemplate] = useCreateBoardingPlaceTemplateMutation();

  return (
    <SaveAsTemplateDialog
      open={open}
      onClose={onClose}
      data={data}
      templateTypeLabel="miejsca wsiadania"
      onSave={async (template) => {
        await createBoardingTemplate({
          name: template.name,
          places: template.data,
        }).unwrap();
      }}
      onSuccess={onSuccess}
    />
  );
};

export default SaveBoardingPlacesAsTemplateDialog;
